import { useContext } from "react";

import { ThemeContext } from "@shapr3d/frontend-lib";

export default function useTheme() {
  const themeContext = useContext(ThemeContext);
  return [themeContext.theme, themeContext.setTheme] as const;
}
